import React, { useCallback, useEffect, useRef } from "react";
import classNames from "classnames";
import Modal from "./modal";
import { graphql, useStaticQuery } from "gatsby";

const CrosslineCompareModal = ({ show, onHide, updateCompare }) => {
  const ref = useRef(null);
  const dialogRef = useRef(null);

  const { labelManagerLabels } = useStaticQuery(graphql`
    {
      labelManagerLabels: labelManagerLabels {
        close
        changeCompare
        changeCompareButton
        descriptionCrosslineModal
        buttonCloseCrosslineHaierCandy
      }
    }
  `);

  const clickBack = useCallback(
    (event) => {
      if (
        event.target !== dialogRef.current &&
        dialogRef.current &&
        !dialogRef.current.contains(event.target)
      ) {
        onHide();
      }
    },
    [onHide]
  );

  useEffect(() => {
    if (show && ref.current) {
      ref.current.focus();
    }
  }, [show]);

  const onKeyDown = useCallback(
    (e) => {
      if (e.key === "Escape") {
        onHide();
      }
    },
    [onHide]
  );

  return (
    <Modal>
      {/* eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex, jsx-a11y/no-noninteractive-element-interactions */}
      <div
        ref={ref}
        className={classNames("language-modal", { show })}
        // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
        tabIndex={show ? 0 : -1}
        // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
        role="dialog"
        aria-hidden={!show}
        // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
        onKeyDown={onKeyDown}
        onClick={clickBack}
      >
        <div className="language-modal__dialog compare-crossline" role="document">
          <div className="language-modal__container">
            <div className="language-modal__title">{labelManagerLabels.changeCompare}</div>
            {labelManagerLabels.descriptionCrosslineModal ? (
              <div className="language-modal__abstract">
                {labelManagerLabels.descriptionCrosslineModal}
              </div>
            ) : (
              <div className="language-modal__abstract"></div>
            )}
            <div className="language-modal__buttons">
              <button
                className="language-modal__close btn-link btn-link--white"
                onClick={() => {
                  updateCompare();
                  onHide();
                }}
              >
                {labelManagerLabels.changeCompareButton}
              </button>
              <button className="language-modal__stay btn-link btn-link--blue" onClick={onHide}>
                {labelManagerLabels.buttonCloseCrosslineHaierCandy}
              </button>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default CrosslineCompareModal;
